import api from '@pray/shared/utils/api';

type CancelCreditsSubscriptionProps = {
  artistId: string;
  subscriptionId: string;
};

export const cancelCreditsSubscription = async ({ artistId, subscriptionId }: CancelCreditsSubscriptionProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!subscriptionId) throw Error('Subscription ID is required');

  const url = `/web/studio/artists/${artistId}/credits/subscription/${subscriptionId}/cancel`;

  await api.executePostRequest(url);
};
